/**
 * Do not edit directly, this file was auto-generated.
 *
 * Base and semantic tokens
 */

var baseTokens = {
  border: {
    radius: {
      "0": "0px",
      "100": "4px",
      "150": "6px",
      "200": "8px",
      "900": "999px"
    },
    width: {
      default: "1px",
      accent: "6px"
    }
  },
  color: {
    transparent: "rgba(255, 255, 255, 0)",
    blue: {
      "100": "rgba(240, 246, 254, 1)",
      "200": "rgba(211, 227, 251, 1)",
      "300": "rgba(185, 211, 248, 1)",
      "400": "rgba(150, 189, 244, 1)",
      "500": "rgba(118, 168, 241, 1)",
      "600": "rgba(62, 133, 235, 1)",
      "700": "rgba(15, 103, 231, 1)",
      "800": "rgba(0, 83, 202, 1)",
      "900": "rgba(0, 59, 143, 1)"
    },
    gray: {
      "0": "rgba(255, 255, 255, 1)",
      "50": "rgba(255, 255, 255, 1)",
      "75": "rgba(249, 248, 246, 1)",
      "100": "rgba(245, 243, 239, 1)",
      "150": "rgba(237, 234, 227, 1)",
      "200": "rgba(231, 230, 228, 1)",
      "300": "rgba(215, 215, 214, 1)",
      "400": "rgba(170, 171, 172, 1)",
      "500": "rgba(138, 141, 143, 1)",
      "600": "rgba(103, 107, 111, 1)",
      "700": "rgba(69, 74, 79, 1)",
      "800": "rgba(45, 50, 57, 1)",
      "850": "rgba(36, 42, 51, 1)",
      "900": "rgba(22, 29, 38, 1)",
      "925": "rgba(13, 17, 23, 1)",
      "1000": "rgba(0, 0, 0, 1)",
      "1000-alpha40": "rgba(0, 0, 0, 0.4)",
      "1000-alpha80": "rgba(0, 0, 0, 0.8)",
      "500-alpha50": "rgba(138, 141, 143, 0.502)",
      "0-alpha50": "rgba(255, 255, 255, 0.502)"
    },
    green: {
      "100": "rgba(233, 250, 237, 1)",
      "200": "rgba(183, 239, 197, 1)",
      "300": "rgba(136, 228, 158, 1)",
      "400": "rgba(67, 213, 101, 1)",
      "500": "rgba(39, 191, 75, 1)",
      "600": "rgba(31, 154, 60, 1)",
      "700": "rgba(26, 126, 49, 1)",
      "800": "rgba(21, 105, 41, 1)",
      "900": "rgba(15, 74, 29, 1)",
      "950": "rgba(11, 61, 23, 1)"
    },
    lightBlue: {
      "100": "rgba(238, 247, 254, 1)",
      "200": "rgba(197, 229, 252, 1)",
      "300": "rgba(166, 215, 251, 1)",
      "400": "rgba(119, 195, 248, 1)",
      "500": "rgba(71, 174, 246, 1)",
      "600": "rgba(43, 140, 209, 1)",
      "700": "rgba(35, 115, 172, 1)",
      "800": "rgba(29, 96, 143, 1)",
      "900": "rgba(21, 67, 101, 1)",
      "950": "rgba(14, 48, 74, 1)"
    },
    orange: {
      "100": "rgba(255, 244, 236, 1)",
      "200": "rgba(255, 218, 194, 1)",
      "300": "rgba(255, 197, 158, 1)",
      "400": "rgba(255, 166, 107, 1)",
      "500": "rgba(255, 132, 51, 1)",
      "600": "rgba(208, 106, 38, 1)",
      "700": "rgba(171, 87, 31, 1)",
      "800": "rgba(142, 72, 26, 1)",
      "900": "rgba(100, 51, 18, 1)"
    },
    pink: {
      "100": "rgba(254, 243, 253, 1)",
      "200": "rgba(253, 213, 249, 1)",
      "300": "rgba(252, 189, 246, 1)",
      "400": "rgba(251, 153, 241, 1)",
      "500": "rgba(246, 117, 233, 1)",
      "600": "rgba(199, 94, 189, 1)",
      "700": "rgba(164, 77, 155, 1)",
      "800": "rgba(136, 64, 128, 1)",
      "900": "rgba(96, 45, 91, 1)"
    },
    purple: {
      "100": "rgba(246, 245, 255, 1)",
      "200": "rgba(226, 223, 253, 1)",
      "300": "rgba(208, 203, 252, 1)",
      "400": "rgba(187, 179, 251, 1)",
      "500": "rgba(165, 154, 250, 1)",
      "600": "rgba(130, 115, 248, 1)",
      "700": "rgba(107, 94, 206, 1)",
      "800": "rgba(88, 78, 171, 1)",
      "900": "rgba(62, 55, 120, 1)",
      "950": "rgba(41, 36, 87, 1)"
    },
    red: {
      "100": "rgba(255, 243, 241, 1)",
      "200": "rgba(253, 217, 211, 1)",
      "300": "rgba(252, 195, 185, 1)",
      "400": "rgba(251, 165, 149, 1)",
      "500": "rgba(250, 133, 112, 1)",
      "600": "rgba(247, 66, 34, 1)",
      "700": "rgba(204, 54, 28, 1)",
      "800": "rgba(169, 45, 23, 1)",
      "900": "rgba(120, 32, 17, 1)",
      "950": "rgba(92, 26, 16, 1)"
    },
    teal: {
      "100": "rgba(209, 255, 245, 1)",
      "200": "rgba(26, 255, 203, 1)",
      "300": "rgba(1, 236, 182, 1)",
      "400": "rgba(1, 212, 164, 1)",
      "500": "rgba(1, 188, 145, 1)",
      "600": "rgba(1, 152, 117, 1)",
      "700": "rgba(0, 125, 97, 1)",
      "800": "rgba(0, 103, 80, 1)",
      "900": "rgba(0, 74, 57, 1)"
    },
    yellow: {
      "100": "rgba(255, 251, 209, 1)",
      "200": "rgba(255, 248, 175, 1)",
      "300": "rgba(247, 235, 115, 1)",
      "400": "rgba(244, 228, 63, 1)",
      "500": "rgba(226, 212, 58, 1)",
      "600": "rgba(203, 190, 53, 1)",
      "700": "rgba(180, 169, 47, 1)",
      "800": "rgba(145, 136, 37, 1)",
      "900": "rgba(119, 111, 31, 1)",
      "925": "rgba(84, 77, 7, 1)",
      "950": "rgba(64, 59, 12, 1)"
    },
    dataVisualization: {
      categorical: {
        violet: {
          "100": "rgba(240, 231, 253, 1)",
          "200": "rgba(221, 203, 251, 1)",
          "300": "rgba(203, 175, 248, 1)",
          "400": "rgba(181, 142, 246, 1)",
          "500": "rgba(156, 104, 243, 1)",
          "600": "rgba(132, 66, 240, 1)",
          "700": "rgba(95, 18, 222, 1)",
          "800": "rgba(71, 13, 165, 1)",
          "900": "rgba(51, 10, 118, 1)",
          desaturated: "rgba(203, 175, 248, 1)"
        },
        cyan: {
          "100": "rgba(235, 255, 254, 1)",
          "200": "rgba(194, 255, 251, 1)",
          "300": "rgba(163, 255, 249, 1)",
          "400": "rgba(133, 255, 248, 1)",
          "500": "rgba(92, 255, 245, 1)",
          "600": "rgba(36, 255, 242, 1)",
          "700": "rgba(0, 209, 197, 1)",
          "800": "rgba(0, 163, 153, 1)",
          "900": "rgba(0, 128, 120, 1)",
          desaturated: "rgba(141, 213, 208, 1)"
        },
        magenta: {
          "100": "rgba(253, 241, 249, 1)",
          "200": "rgba(250, 214, 238, 1)",
          "300": "rgba(246, 177, 223, 1)",
          "400": "rgba(243, 145, 209, 1)",
          "500": "rgba(239, 108, 194, 1)",
          "600": "rgba(233, 58, 173, 1)",
          "700": "rgba(208, 23, 145, 1)",
          "800": "rgba(144, 34, 107, 1)",
          "900": "rgba(103, 24, 76, 1)",
          desaturated: "rgba(246, 177, 223, 1)"
        },
        periwinkle: {
          "100": "rgba(229, 235, 255, 1)",
          "200": "rgba(199, 211, 255, 1)",
          "300": "rgba(168, 187, 255, 1)",
          "400": "rgba(133, 160, 255, 1)",
          "500": "rgba(93, 129, 255, 1)",
          "600": "rgba(51, 96, 255, 1)",
          "700": "rgba(0, 56, 255, 1)",
          "800": "rgba(0, 39, 178, 1)",
          "900": "rgba(0, 28, 128, 1)",
          desaturated: "rgba(168, 187, 255, 1)"
        },
        redOrange: {
          "100": "rgba(254, 241, 236, 1)",
          "200": "rgba(252, 224, 212, 1)",
          "300": "rgba(251, 203, 183, 1)",
          "400": "rgba(249, 175, 144, 1)",
          "500": "rgba(247, 151, 110, 1)",
          "600": "rgba(243, 108, 50, 1)",
          "700": "rgba(241, 82, 14, 1)",
          "800": "rgba(193, 66, 11, 1)",
          "900": "rgba(135, 46, 8, 1)",
          desaturated: "rgba(249, 175, 144, 1)"
        },
        chartreuse: {
          "100": "rgba(246, 255, 235, 1)",
          "200": "rgba(227, 249, 200, 1)",
          "300": "rgba(213, 253, 165, 1)",
          "400": "rgba(190, 252, 115, 1)",
          "500": "rgba(167, 252, 65, 1)",
          "600": "rgba(137, 245, 4, 1)",
          "700": "rgba(114, 205, 4, 1)",
          "800": "rgba(93, 167, 3, 1)",
          "900": "rgba(70, 125, 2, 1)",
          desaturated: "rgba(183, 218, 140, 1)"
        }
      },
      sequential: {
        warm: {
          "50": "rgba(246, 247, 222, 1)",
          "75": "rgba(240, 240, 178, 1)",
          "100": "rgba(244, 228, 63, 1)",
          "200": "rgba(254, 192, 45, 1)",
          "300": "rgba(255, 156, 58, 1)",
          "400": "rgba(247, 118, 89, 1)",
          "500": "rgba(220, 92, 114, 1)",
          "600": "rgba(184, 71, 134, 1)",
          "700": "rgba(143, 54, 143, 1)",
          "800": "rgba(98, 36, 137, 1)",
          "900": "rgba(51, 10, 118, 1)"
        },
        cool: {
          "50": "rgba(232, 244, 185, 1)",
          "75": "rgba(208, 241, 126, 1)",
          "100": "rgba(137, 245, 4, 1)",
          "200": "rgba(51, 230, 101, 1)",
          "300": "rgba(0, 206, 138, 1)",
          "400": "rgba(0, 181, 161, 1)",
          "500": "rgba(0, 154, 169, 1)",
          "600": "rgba(0, 126, 170, 1)",
          "700": "rgba(0, 97, 162, 1)",
          "800": "rgba(0, 66, 148, 1)",
          "900": "rgba(0, 28, 128, 1)"
        },
        blue: {
          "75": "rgba(216, 253, 251, 1)",
          "100": "rgba(194, 255, 251, 1)",
          "200": "rgba(168, 233, 239, 1)",
          "300": "rgba(144, 210, 227, 1)",
          "400": "rgba(122, 185, 214, 1)",
          "500": "rgba(104, 159, 201, 1)",
          "600": "rgba(88, 130, 186, 1)",
          "700": "rgba(75, 99, 166, 1)",
          "800": "rgba(63, 63, 144, 1)",
          "900": "rgba(51, 10, 118, 1)"
        },
        orange: {
          "75": "rgba(252, 248, 207, 1)",
          "100": "rgba(255, 248, 175, 1)",
          "200": "rgba(252, 228, 144, 1)",
          "300": "rgba(250, 208, 117, 1)",
          "400": "rgba(248, 185, 91, 1)",
          "500": "rgba(245, 161, 70, 1)",
          "600": "rgba(239, 136, 55, 1)",
          "700": "rgba(229, 111, 46, 1)",
          "800": "rgba(217, 84, 42, 1)",
          "900": "rgba(201, 55, 44, 1)"
        },
        green: {
          "75": "rgba(241, 253, 226, 1)",
          "100": "rgba(227, 254, 195, 1)",
          "200": "rgba(201, 235, 180, 1)",
          "300": "rgba(177, 215, 166, 1)",
          "400": "rgba(151, 195, 149, 1)",
          "500": "rgba(125, 174, 134, 1)",
          "600": "rgba(100, 151, 117, 1)",
          "700": "rgba(73, 127, 99, 1)",
          "800": "rgba(43, 102, 79, 1)",
          "900": "rgba(0, 74, 57, 1)"
        }
      }
    }
  },
  elevation: {
    zIndex: {
      layer0: "auto",
      layer1: "1",
      layer2: "300",
      layer3: "500",
      layer4: "700"
    }
  },
  font: {
    family: {
      ember: "'Amazon Ember', Helvetica, sans-serif",
      code: "'Amazon Ember Mono', monospace",
      display: "'Ember Modern Display Standard', 'Amazon Ember', Helvetica, sans-serif"
    },
    letterSpacing: {
      display: "0.7px",
      ember: "0px",
      code: "0px"
    },
    size: {
      "250": "0.625rem",
      "275": "0.6875rem",
      "300": "0.75rem",
      "325": "0.8125rem",
      "350": "0.875rem",
      "375": "0.9375rem",
      "400": "1rem",
      "425": "1.0625rem",
      "450": "1.125rem",
      "500": "1.25rem",
      "525": "1.3125rem",
      "550": "1.375rem",
      "600": "1.5rem",
      "650": "1.625rem",
      "700": "1.75rem",
      "800": "2rem",
      "1000": "2.5rem",
      "1200": "3rem"
    },
    weight: {
      "100": 100,
      "200": 200,
      "300": 300,
      "400": 400,
      "500": 500,
      "600": 600,
      "700": 700,
      "800": 800,
      "900": 900
    }
  },
  layout: {
    maxWidth: {
      xsmall: "20rem",
      small: "33.75rem",
      base: "60rem",
      large: "82.5rem",
      fluid: "100%"
    }
  },
  portalElementId: "portal",
  inlinePortalZIndexIncrement: 10000,
  spacing: {
    "0": "0rem",
    "100": "0.25rem",
    "125": "0.3125rem",
    "150": "0.375rem",
    "175": "0.4375rem",
    "200": "0.5rem",
    "225": "0.5625rem",
    "250": "0.625rem",
    "275": "0.6875rem",
    "300": "0.75rem",
    "325": "0.8125rem",
    "350": "0.875rem",
    "400": "1rem",
    "450": "1.125rem",
    "500": "1.25rem",
    "550": "1.375rem",
    "600": "1.5rem",
    "650": "1.625rem",
    "700": "1.75rem",
    "800": "2rem",
    "900": "2.25rem",
    "1000": "2.5rem",
    "1100": "2.75rem",
    "1200": "3rem",
    "1600": "4rem",
    "025": "0.0625rem",
    "050": "0.125rem",
    "075": "0.1875rem"
  }
};

export { baseTokens as b };
//# sourceMappingURL=base-BusbZM5v-BusbZM5v.js.map
